import { useState, useEffect } from 'react';
import { useToggle, } from 'react-use';

export default function useDocumentsFetch (refs, dependencies = [], { initialItems = [], detail = false, } = {}) {
  const [items, setItems] = useState(initialItems);
  const [isLoading, toggleLoading] = useToggle(false);
  useEffect(() => {
    if(!refs) return setItems(initialItems);

    toggleLoading(true);
    let cleanedUp = false;
    (async () => {
      const data = (await Promise.all(refs.map(_ => _.get())))
        .filter(_ => _.exists)
        .map(_ => ({ id: _.id, ref: _.ref, ..._.data() }));
      if(!cleanedUp) {
        setItems(data);
      }
      toggleLoading(false);
    })();

    return _ => cleanedUp = true;
  }, dependencies);
  return detail ? { items, isLoading } : items;
};
